import Router from 'vue-router';

import { afterEach, beforeEach } from '@/router/router-methods';
import { routes as rootRoutes } from '@/router/root';
import {
  adminGroup,
  homeGroup,
  myToolsGroup,
  reportsGroup,
  businessMenuGroup,
  authMenuGroup,
  businessMetricsGroup,
  myCustomersGroup,
  coinStoreGroup,
  ticketGroup,
  portalGroup
} from './groups';
import { Group } from './group.model';

function extractRoutes(routes: any) {
  const result: any = [];
  function traverse(routes: any) {
    for (let i = 0; i < routes.length; i++) {
      const route = routes[i];

      if (route.routes && route.routes.length > 0) {
        traverse(route.routes);
      } else {
        result.push(route);
      }
    }
  }

  traverse(routes);
  return result;
}

const groups: Group[] = [
  adminGroup,
  coinStoreGroup,
  ticketGroup,
  homeGroup,
  myToolsGroup,
  reportsGroup,
  myCustomersGroup,
  businessMetricsGroup,
  businessMenuGroup,
  authMenuGroup,
  portalGroup
];

const routes: any[] = extractRoutes([
  ...adminGroup.routes,
  ...coinStoreGroup.routes,
  ...ticketGroup.routes,
  ...homeGroup.routes,
  ...myToolsGroup.routes,
  ...reportsGroup.routes,
  ...myCustomersGroup.routes,
  ...businessMetricsGroup.routes,
  ...businessMenuGroup.routes,
  ...portalGroup.routes,
  ...rootRoutes
]);

const buildRouter = (router: any): Router => {
  const routerInstance = new router({
    mode: 'history',
    base: `${process.env.BASE_URL}`,
    routes: routes
  });

  routerInstance.afterEach(afterEach);

  routerInstance.beforeEach(beforeEach);

  return routerInstance;
};

export { buildRouter, routes, groups };
export default buildRouter;
